// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"b58d05c8","600":"cf87f587"}[chunkId] + ".chunk.css";
};